export default function Puzzles(props) {
  return (
    <svg
      id="Component_29_25"
      data-name="Component 29 – 25"
      xmlns="http://www.w3.org/2000/svg"
      width="19.981"
      height="20"
      viewBox="0 0 19.981 20"
      {...props}>
      <path
        id="Path_5828"
        data-name="Path 5828"
        d="M536.338,1.569a3.171,3.171,0,0,1,3.735,1.269,3.093,3.093,0,0,1-.009,3.559,3.2,3.2,0,0,1-3.726,1.262V7.9c0,1.01,0,2.02,0,3.029a1.426,1.426,0,0,1-1.517,1.523c-1.01,0-2.019,0-3.029,0h-.247a3.168,3.168,0,0,1-1.319,3.755,2.976,2.976,0,0,1-3.516-.034,3.141,3.141,0,0,1-1.256-3.721h-.532c-.913,0-1.826,0-2.74,0a1.429,1.429,0,0,1-1.528-1.534c0-1.477,0-2.955,0-4.432a.753.753,0,0,1,.431-.783.738.738,0,0,1,.85.2,1.779,1.779,0,0,0,2.818-2.052,1.8,1.8,0,0,0-2.812-.534.819.819,0,0,1-.658.261.718.718,0,0,1-.625-.768q0-1.982,0-3.965c0-.215,0-.431,0-.646a1.414,1.414,0,0,1,1.431-1.427c1.537-.007,3.073,0,4.611,0a.705.705,0,0,1,.71.438.71.71,0,0,1-.181.814,1.786,1.786,0,0,0,.453,2.836,1.8,1.8,0,0,0,2.223-.5,1.762,1.762,0,0,0-.1-2.288.814.814,0,0,1-.275-.674.7.7,0,0,1,.682-.618c1.6-.006,3.193-.015,4.789,0a1.388,1.388,0,0,1,1.334,1.4c.01,1.047,0,2.094,0,3.14Z"
        transform="translate(540.632 16.767) rotate(180)"
        fill="#fff"
      />
    </svg>
  );
}
